export const hyphenCase = s => s.replace(/[A-Z]/g, '-$&').toLowerCase()

/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */
export const arrayContainsArray = (superset, subset) =>
  subset.every(function (value) {
    return superset.indexOf(value) >= 0
  })

export const padZeros = (num, size) => {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

export const SETTINGS = {
  LEADING_ZEROS: 4,
  PURCHASE_ORDER_NUMBER_FORMAT: '[PO]YY[-]',
  SALES_ORDER_NUMBER_FORMAT: '[SO]YY[-]',
  INVOICE_NUMBER_FORMAT: '[INV]YY[-]',
  SHIPPING_NOTE_NUMBER_FORMAT: '[SHP]YY[-]'
}

import _ from 'lodash'

/**
 * returns the payload (object or array) with specified properties
 * recursivly
 *
 * ex. obj = { a: 'a', b: 'b', c: 'c'}
 * pickDeep(obj, ['a']) => { a: 'a'}
 *
 * ex. obj = { a: 'a', b: 'b', c: { a:1, b:2}}
 * pickDeep(obj, ['a', {c: ['a']}]) => { a: 'a', c: { a:1 } }
 *
 * ex. obj = { a: 'a', b: 'b', c: [{ a:1, b:2},{ a:12, b:22}]}
 * pickDeep(obj, ['a', {c: ['a']}]) => { a: 'a', c: [{ a:1 }, {a: 12}] }
 *
 * @param {array|object}  payload
 * @param {array} properties
 *
 * @returns {array|object}
 */
export const pickDeep = (payload, properties) => {
  var copy = {}

  if (Array.isArray(payload)) {
    return payload.map(p => _.pick(p, properties))
  }

  const _props = properties.filter(p => typeof p === 'string')
  copy = { ...copy, ..._.pick(payload, _props) }

  const _objProps = properties.filter(p => typeof p === 'object')
  for (const prop of _objProps) {
    for (const key of Object.keys(prop)) {
      copy = { ...copy, [key]: pickDeep(payload[key], prop[key]) }
    }
  }

  return copy
}

export const isDecimal = (value, { decimals = '*', separator = '.' } = {}) => {
  if (value === null || value === undefined || value === '') {
    return false
  }
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value)
  }
  const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
  const regex = new RegExp(
    `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
  )

  return regex.test(value)
}
